import React from 'react'
import { Box, Icon, IconButton, SearchField, Card, Button, Layer, Text, TextField } from 'gestalt';
import 'gestalt/dist/gestalt.css';
import { Link } from 'react-router-dom';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            value: '',
            show_o: false
     };
    }

    render() {
        return (
        <div>
            <Box color={this.props.color} shape="rounded" padding={3} display="flex" direction="row" alignItems="center">
                <Box padding={3}>
                    <Icon
                        icon="knoop"
                        color="orange"
                        size={20}
                        accessibilityLabel="Bracket"
                    />
                </Box>
                <Box flex="grow" paddingX={2}>
                    <SearchField
                        accessibilityLabel="Button. Find all the content you love."
                        id="searchField"
                        onChange={({ value }) => this.setState({value: value})}
                        placeholder="Button"
                        autoComplete='off'
                    />
                    {this.state.value && 
                        <Card
                            active={this.state.value === ''}
                        >
                                <Box column={12}>
                                    <Box column={6}></Box>
                                <Box column={3}>
                                    <Button
                                        text='Search'
                                        color='gray'
                                        onClick={()=>window.location.replace('/search/'+this.state.value)}
                                        inline
                                    />
                                </Box>
                                </Box>
                                
                        </Card>
                    }
                </Box>
                <Box paddingX={2}>
                    <IconButton
                        accessibilityLabel="Write"
                        icon="add"
                        size="md"
                        onClick={()=>{this.setState({ show_o: true })}}
                    />
                </Box>
                <Box paddingX={2}>
                    <Link to='/profile'><IconButton accessibilityLabel="Profile" icon="person" size="md" /></Link>
                </Box>
            </Box>

            {this.state.show_o && 
            <Layer>
                <Box direction='column' color="white" position="fixed" top left right bottom display="flex" alignItems="center" justifyContent="center">
                <Box color="white" padding={3} display="flex" alignItems="center">
                  <Box>
                    <IconButton
                      accessibilityLabel="Close"
                      icon="cancel"
                      onClick={()=>{this.setState({ show_o: false })}}
                    />
                  </Box>
                </Box>

                <Box color="white" padding={3} alignItems='start'>
                    <h1>
                        <Text color='orange'>Help build the Community. Is there a blog you would love to suggest?</Text>
                    </h1>

                    <TextField type='url' placeholder='Suggested link(eg http://lindaikejisblog.com)' helperText='Blog URL(eg. http://lindaikejisblog.com)' />
                    <Button inline text='Submit' />
                </Box>

                </Box>
            </Layer>}
        </div>
        );
    }
}

export default Header;